/** Platform admin brand — used when a tenant has no custom colors. */

export const PLATFORM_PRIMARY = '#173A5E';
export const PLATFORM_SECONDARY = '#5C6B7A';

const LEGACY_DEFAULTS = new Set([
  '#1976d2',
  '#1976D2',
  '#2563eb',
  '#2563EB',
  '#dc004e',
  '#DC004E',
  '#7c3aed',
  '#7C3AED',
  '#0F766E',
  '#0f766e',
  '#1E3A8A',
  '#1e3a8a',
  '#0B5F59',
  '#0b5f59',
]);

export function resolveBrandColor(value: string | undefined | null, fallback: string): string {
  const color = String(value || '').trim();
  if (!color || LEGACY_DEFAULTS.has(color)) return fallback;
  return color;
}
